<template>
    <div>
        <DeleteDraftWindow @confirmDelete="confirmDelete"/>
        <div class="mail-list">

            <div v-for="mail in mails" class="mail-item" :class="{'sub-stopped': mail.canceledByAdmin}">
                <div @click="deleteMail(mail)" class="button-mail-delete draft-delete">
                    <DeleteIcon/>
                </div>
                <div class="mail-left">
                    <div class="title"><a :href="'/mail?id=' + mail.id">{{ getMailTopic(mail.topic) }}</a></div>
                    <div class="text">
                        {{ getMailText(mail.text) }}
                    </div>
                    <div class="files">
                        <div v-for="file in mail.attachmentList" class="file-item">
                            <div class="file-thumb">
                                <img v-if="file.name.substring(file.name.lastIndexOf('.') + 1) === 'docx'"
                                     src="../../img/attach-doc-docx.svg">
                                <img v-else-if="file.name.substring(file.name.lastIndexOf('.') + 1) === 'pdf'"
                                     src="../../img/attach-doc-pdf.svg">
                                <img v-else-if="file.type === 'video'" src="../../img/attach-video-error.jpg">
                                <img v-else :src="getFilePath(file)">
                            </div>
                            <div class="file-name">{{ getFilename(file.name) }}</div>
                        </div>
                    </div>
                </div>
                <div class="mail-right">
                    <div class="mail-addressess">
                        <div class="label">Кому:</div>
                        <div v-if="mail.recepientList.length === 0" class="item">
                            <span class="item-email">Не указано</span>
                        </div>
                        <div v-for="recepient in getRecepients(mail.recepientList)" class="item">
                            <span class="item-email">({{ recepient }})</span>
                        </div>
                        <div v-if="mail.receiverPhone !== null" class="mail-phone">
                            <div class="label">Номер телефона получателя:</div>
                            <div class="item">{{mail.receiverPhone}}</div>
                        </div>
                    </div>
                    <div class="mail-date">
                        <div class="row">
                            <div class="label">Дата создания:</div>
                            <div class="item">{{ mail.createdStr }}</div>
                        </div>
                        <div class="row" v-show="mail.sendDate">
                            <div class="label">Дата отправки:</div>
                            <div class="item">{{ mail.sendDateStr }}</div>
                        </div>
                    </div>
                    <button @click="subscribe(mail.id)"
                            class="button button-dark"
                            :disabled="!isAllFieldsFilled(mail)"
                    >
                        {{mail.canceledByAdmin ? 'Возобновить подписку' : 'Оформить подписку'}}
                    </button>
                </div>
            </div>

        </div>

        <div v-show="pageCount > 1" class="pagination">
            <ul>
                <li @click="firstPage" class="nav nav-first" :class="{'disabled' : pageNumber === 0}"><span><ArrowFirstIcon/></span>
                </li>
                <li @click="prevPage" class="nav nav-prev" :class="{'disabled' : pageNumber === 0}"><span><ArrowPrevIcon/></span>
                </li>
                <li v-for="i in pagesToShow" :class="{'active' : i === pageNumber + 1}" @click="goToPage(i - 1)">
                    <span v-if="i === pageNumber + 1">{{ i }}</span>
                    <a v-else href="#">{{ i }}</a>
                </li>
                <li @click="nextPage" class="nav nav-next" :class="{'disabled' : pageNumber + 1 === pageCount}">
                    <span><ArrowPrevIcon/></span></li>
                <li @click="lastPage" class="nav nav-last" :class="{'disabled' : pageNumber + 1 === pageCount}"><span><ArrowFirstIcon/></span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import DeleteIcon from "../icons/DeleteIcon";
import ArrowPrevIcon from "../icons/ArrowPrevIcon";
import ArrowFirstIcon from "../icons/ArrowFirstIcon";
import WarningIcon from "../icons/WarningIcon";
import DeleteDraftWindow from "../windows/DeleteDraftWindow";
import rest from "../../restUtils";
import router from "../../router";

const appUrl = process.env.VUE_APP_GLOBAL_URL;

export default {
    name: "drafts",
    components: {
        DeleteDraftWindow,
        WarningIcon,
        DeleteIcon,
        ArrowPrevIcon,
        ArrowFirstIcon
    },
    props: ['drafts'],
    data() {
        return {
            size: 10,
            pageNumber: 0,
            mails: [],
            pageCount: 0,
            mailToDelete: {}
        }
    },

    created() {
        this.pageCount = this.getPageCount();
        this.mails = this.getPaginatedData();
    },

    computed: {
        pagesToShow() {
            let result = [];
            if (this.pageCount < 5) {
                for (let i = 0; i < this.pageCount; i++) {
                    result[i] = i + 1;
                }
            } else {
                let start = this.pageNumber + 1;
                let finish = start + 5;
                if (finish > this.pageCount) {
                    start = this.pageCount - 4;
                }
                for (let i = 0; i < 5; i++) {
                    result[i] = start + i;
                }
            }
            return result;
        }
    },

    methods: {
        getFilename(name) {
            let ext = name.substring(name.lastIndexOf('.') + 1);
            let fileName = name.substring(0, name.lastIndexOf('.'));
            return fileName.length > 9 ? fileName.substr(0, 9) + '...' + ext : fileName + '.' + ext;
        },
        getFilePath(img) {
            if (img.scaledFilename !== null) {
                return appUrl + '/files' + img.scaledFilename;
            }
            return appUrl + '/files' + img.fullname;
        },
        isVideoSupports(fullname) {
            let ext = fullname.substr(fullname.lastIndexOf('.'));
            return ext === 'mp4';
        },
        getRecepients(recepientList) {
            let recepients = recepientList.split(',');
            if (recepients.length === 1 && recepients[0] === '') {
                recepients = []
            }
            return recepients;
        },
        nextPage() {
            if (this.pageNumber + 1 < this.pageCount) {
                this.pageNumber++;
                this.mails = this.getPaginatedData();
            }
        },
        prevPage() {
            if (this.pageNumber > 0) {
                this.pageNumber--;
                this.mails = this.getPaginatedData();
            }
        },
        goToPage(page) {
            this.pageNumber = page;
            this.mails = this.getPaginatedData();
        },
        firstPage() {
            this.pageNumber = 0;
            this.mails = this.getPaginatedData();
        },
        lastPage() {
            this.pageNumber = this.pageCount - 1;
            this.mails = this.getPaginatedData();
        },
        deleteMail(mail) {
            this.mailToDelete = mail;
            $('.window-wrapper.window-mail-draft-delete').addClass('window-open');
            $('body').addClass('blocked');
        },
        getPaginatedData() {
            const start = this.pageNumber * this.size,
                end = start + this.size;
            return this.drafts.slice(start, end);
        },
        getPageCount() {
            let l = this.drafts.length,
                s = this.size;
            return Math.ceil(l / s);
        },
        confirmDelete() {
            let mail = this.mailToDelete;
            rest.doDelete('/mail/' + mail.id);
            let index = this.drafts.indexOf(mail);
            this.drafts.splice(index, 1);
            this.pageCount = this.getPageCount();
            if (this.pageNumber >= this.pageCount) {
                this.pageNumber = this.pageCount - 1;
            }
            this.mails = this.getPaginatedData();
        },
        subscribe(id) {
            router.push({path: '/subscribe', query: {id: id, returnPage: 'mails?tab=drafts'}});
        },
        getMailText(text) {
            if (text.length > 110) {
                return text.substr(0, 110) + "...";
            } else {
                return text;
            }
        },
        getMailTopic(topic) {
            if (topic.trim() === '') {
                return '(Без темы)';
            } else {
                return topic;
            }
        },

        isAllFieldsFilled(mail) {
            return mail.recepientList.length > 0 && mail.topic.trim() !== '';
        }
    }
}
</script>

<style scoped>

</style>